// Meta Pixel utility — initializes the Facebook Pixel and exposes typed helpers.

declare global {
  interface Window {
    fbq?: ((...args: any[]) => void) & {
      callMethod?: (...args: any[]) => void
      queue?: any[]
      push?: any
      loaded?: boolean
      version?: string
    }
    _fbq?: Window['fbq']
  }
}

const PIXEL_ID = '1646037409785153'

let initialized = false

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  // Standard Meta Pixel base code
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      document.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq?.('init', PIXEL_ID)
}

export function trackPageView(): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'PageView')
}

export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', 'AddToCart', {
    value: params?.value ?? 6.99,
    currency: params?.currency ?? 'USD',
    content_name: params?.content_name ?? 'Arquitecto de Crédito USA',
  })
}
